// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"0b5c1a1c","98":"a09cae03","450":"55f1f7c5","813":"ac39b240","821":"429ae1b4","836":"f412e326","890":"b094771d"}[chunkId] + ".chunk.js";
};